import { render, staticRenderFns } from "./TrangCapNhatGroup.vue?vue&type=template&id=404e77fb&"
import script from "./TrangCapNhatGroup.vue?vue&type=script&lang=js&"
export * from "./TrangCapNhatGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports